import { render, staticRenderFns } from "./elInput.vue?vue&type=template&id=070f430c"
import script from "./elInput.vue?vue&type=script&lang=js"
export * from "./elInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports